/* eslint-disable no-bitwise */

export const uuid = () =>
  'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (character) => {
    const seed = (Math.random() * 16) | 0;
    const value = character === 'x' ? seed : (seed & 0x3) | 0x8;
    return value.toString(16);
  });
